export default "__VITE_ASSET__zDKft1Hp__"